import { createContext } from 'use-context-selector'
import { DatabaseDetailContextProps } from './types'

export const DatabaseDetailContext = createContext(
  {} as DatabaseDetailContextProps
)
